import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error'
import { useNavigate } from "react-router-dom";


const ReceivePayments = ({ work_order, onWorkOrderChange }) => {
    const navigate = useNavigate();

    const [isBtn, setIsBtn] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [payments, setPayments] = useState(null);
 
    const [paymentAdd, setPaymentAdd] = useState(null);
    const [inputError, setInputError] = useState(false);



  

    useEffect(() => {
       
        if (work_order?.work_order_id > 0 && work_order?.status >= 4) {
            getPayments();
  
        }


    }, [work_order?.work_order_id, work_order?.status]);

   


    const getPayments = async () => {

        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-payments-by-work-order-id/"+ work_order?.work_order_id,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {

                if (response?.data?.status) {

                    setPayments(response?.data?.payments)



                } else {
                    Swal.fire({ icon: "error", title: "payment Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {
                catchError(error,navigate)

            });


    }


    const addPayment = async () => {

        setPaymentAdd(null);
        setAddMode(true);

    }


    const savePayment = async (e) => {


        setIsBtn(true);
      
        if ( !paymentAdd?.payment_amount || !paymentAdd?.payment_reference ||  !paymentAdd?.payment_amount?.toString().match(/^[0-9]*\.\d{1,2}$/)) {

        

            setInputError(true);
            setIsBtn(false);

        } else {

            var payment_info = {
                work_order_id: work_order?.work_order_id,
                payment_amount: paymentAdd?.payment_amount,
                payment_reference: paymentAdd?.payment_reference,
                payment_notes: paymentAdd?.payment_notes,
               
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-payment", payment_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    payment_info.payment_id = response?.data?.payment_id;
                  getPayments();
                    setAddMode(false)
                    onWorkOrderChange({ status: 6 });


                } else {

                    Swal.fire({ icon: "error", title: "Book Keeping Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error,navigate)

            });

        }


    }



    const removePayment = async (payment_id) => {

        setIsBtn(true);
        let error_flag = false;

        
       
        if ( !payment_id  ) {

            error_flag = true;
        }

        if (error_flag) {

            Swal.fire({ icon: "error", title: "payment Info", text: "unable to remove" });

        } else {


            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
              }).then((result) => {
                if (result.isConfirmed) {
                      
            var payment_info = {
                payment_id: payment_id,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/remove-payment", payment_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    getPayments();
                  
                    setAddMode(false)


                } else {

                    Swal.fire({ icon: "error", title: "payment Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error,navigate)

            });

                 
                }
              });
            
        }


    }

 

    return (
        <>


            {(work_order?.status >= 4) &&

                <>
                    <div className="row mt-2 mx-0 sub-heading">
                        <div className="col py-1">

                            <div className=" py-2 fw-bold text-dark">RECEIVE PAYMENTS</div>

                        </div>
                        <div className="col py-1 text-end">

                            {addMode ? 
                            <>
                                    <button onClick={() => savePayment()} className="btn btn-sm  btn-success me-1 mt-1" type="button" disabled={isBtn?true:false} >{isBtn?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"SAVE"}</button>
                                    <button onClick={() => { setAddMode(false); setPaymentAdd(null); }} className="btn btn-sm  btn-warning me-1 mt-1" type="button">CANCEL SAVE</button>
                                    </>
                                :
                                <>
                                  
                                                <button disabled={work_order.status<5 || work_order.status>6} onClick={() => addPayment()} className="btn btn-sm    btn-success me-1 mt-1" type="button">ADD</button>
                                         
                                       
                                </>
                            }

                        </div>


                    </div>

                    {(addMode) ?
                        <>
                            <form method="post" action="" encType="multipart/form-data" name="updates" id="updates">
                                <div className="row px-3 py-2 gx-2 ">
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Amount(USD):dd.cc</label>
                                        <input name="payment_amount" className="form-control"
                                            value={paymentAdd?.v}
                                            onChange={(e) =>
                                                setPaymentAdd({ ...paymentAdd, payment_amount: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!paymentAdd?.payment_amount || !paymentAdd?.payment_amount.toString().match(/^[0-9]*\.\d{1,2}$/)) && (
                                                <span className="text-danger">Enter facility fee in dd.cc format</span>
                                            )}
                                    </div>
                                    <div className="col-md-3 col-sm-3">
                                        <label className="control-label">Check/Reference Number*</label>

                                        <input name="payment_reference" className="form-control"
                                            value={paymentAdd?.payment_reference}
                                            onChange={(e) =>
                                                setPaymentAdd({ ...paymentAdd, payment_reference: e.target.value })
                                            }

                                        />
                                        {inputError &&
                                            (!paymentAdd?.payment_reference) && (
                                                <span className="text-danger">Enter Check/Reference Number</span>
                                            )}


                                    </div>
                                   
                               
                                    <div className="col-6">
                                        <label htmlFor="payment_notes">PAYMENT NOTES</label>
                                        <textarea rows="1" name="payment_notes" id="payment_notes"
                                            className="form-control"
                                            onChange={(e) =>
                                                setPaymentAdd({ ...paymentAdd, payment_notes: e.target.value })
                                            }

                                        >
                                            {paymentAdd?.payment_notes}
                                        </textarea>


                                    </div>
                                  

                                </div>

                           

                            </form>

                        </>
                        :
                       
                                <>
                                    {(payments) ?
                                        <>

                                <div className="row px-3 py-2 gx-2 ">
                                <div className="col-md-2 col-sm-2">
                                        <label className="control-label">Date: </label>
                                    </div>
                                    <div className="col-md-2 col-sm-2">
                                        <label className="control-label">Amount(USD): </label>
                                    </div>
                                    <div className="col-md-2 col-sm-2">
                                        <label className="control-label">Reference:</label>
                                    </div>
                                    <div className="col-md-2 col-sm-2">
                                        <label className="control-label">Recorded By:</label>
                                    </div>
                                 
                                    <div className="col-xl-2 col-lg-2 col-sm-2 col-2">
                                        <label htmlFor="payment_notes">PAYMENT NOTES:</label>
                                    </div>
                                  

                                </div>

                                {payments.map((p, index) => {
        return (
                                <div className="row px-3 py-2 gx-2 ">
                                <div className="col-md-2 col-sm-2">
                                        <label className="field-info" >
                                         {work_order.status<7 && 
                                            <i className="btn btn-sm btn-sm btn-danger me-1" onClick={()=>{removePayment(p.payment_id)}} >Del</i>
                                }
                                            {p?.payment_date_p}</label>
                                    </div>
                                    <div className="col-md-2 col-sm-2">
                                        <label className="field-info" >{parseFloat(p?.payment_date).toFixed(2)}</label>
                                    </div>
                                    <div className="col-md-2 col-sm-2">
                                        <label className="field-info" >{p?.payment_reference}</label>
                                    </div>
                                    <div className="col-md-2 col-sm-2">
                                        <label className="field-info" >{p?.payment_recorded_by}</label>
                                    </div>
                                 
                                    <div className="col-xl-2 col-lg-2 col-sm-2 col-2">
                                        <label className="field-info" >{p?.payment_notes?p?.payment_notes:""}</label>
                                    </div>
                                  

                                </div>
        )})}
    

                                    </>
                                        :
                                        <div className="row " >

                                            <div className="col-xl-12 col-lg-12 py-4 px-3" >

                                                <h5>No payment has been received yet.</h5>

                                            </div>

                                        </div>
                                    }
                                </>
                          
                    }


                </>
            }
        </>
    )

}
export default ReceivePayments;